module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    attrs: {
      "id": _vm.thisId
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ea3c14f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tinymce.vue
// module id = 611
// module chunks = 2